export const BASE_URL = process.env.REACT_APP_API_ENDPOINT

export const OPEN_RESPONSE_MODALL_PROJECT_CODE = 'OPEN_RESPONSE_MODALL_PROJECT_CODE'
export const SET_KEYWORD_SEARCHL_PROJECT_CODE = 'SET_KEYWORD_SEARCHL_PROJECT_CODE'

export const PROJECT_CODE_NON_SERVICE_GET_REQUEST = 'PROJECT_CODE_NON_SERVICE_GET_REQUEST'
export const PROJECT_CODE_NON_SERVICE_GET_SUCCESS = 'PROJECT_CODE_NON_SERVICE_GET_SUCCESS'
export const PROJECT_CODE_NON_SERVICE_GET_FAILURE = 'PROJECT_CODE_NON_SERVICE_GET_FAILURE'
export const PROJECT_CODE_NON_SERVICE_GET_RESET = 'PROJECT_CODE_NON_SERVICE_GET_RESET'

export const PROJECT_CODE_NON_SERVICE_EDIT_REQUEST = 'PROJECT_CODE_NON_SERVICE_EDIT_REQUEST'
export const PROJECT_CODE_NON_SERVICE_EDIT_SUCCESS = 'PROJECT_CODE_NON_SERVICE_EDIT_SUCCESS'
export const PROJECT_CODE_NON_SERVICE_EDIT_FAILURE = 'PROJECT_CODE_NON_SERVICE_EDIT_FAILURE'
export const PROJECT_CODE_NON_SERVICE_EDIT_RESET = 'PROJECT_CODE_NON_SERVICE_EDIT_RESET'

export const SHOW_MANUAL_PROJECT_CODE = 'SHOW_MANUAL_PROJECT_CODE'
export const CLOSE_MANUAL_PROJECT_CODE = 'CLOSE_MANUAL_PROJECT_CODE'



// WEBPACK FOOTER //
// ./src/actions/project-code/types.js